// extracted by mini-css-extract-plugin
export var section = "glance-module--section--3h_oi";
export var header = "glance-module--header--2XyEp";
export var header_inner = "glance-module--header_inner--3NaJb";
export var jsAnimInit = "glance-module--jsAnimInit--1yFCk";
export var logo = "glance-module--logo--2tQzd";
export var title = "glance-module--title--33bCV";
export var subtitle = "glance-module--subtitle--6mhXo";